import BottomSheet from "../../../components/BottomSheet/BottomSheet"
import FeatureList from "../../../components/FeatureList/FeatureList"
import useStrings from "../../../localization/useStrings"
import images from "../../../utils/images"
import { useFreeTrialPaywall } from "../freeTrialPaywallContext"
import styles from "./FeaturesSheet.module.scss"

const FeaturesSheet = () => {
  const { actions, state } = useFreeTrialPaywall()
  const strings = useStrings().freeTrialPaywall.featureList

  return (
    <BottomSheet
      visible={state.showFeaturesSheet}
      onClose={() => actions.setShowFeaturesSheet(false)}
    >
      <div className={styles.container}>
        <label className={styles.title}>{strings.title}</label>
        <div className={styles.info}>
          <div className={styles.infoTextContainer}>
            <label className={styles.infoTitle}>{strings.infoTitle}</label>
            <label className={styles.infoSubtitle}>{strings.infoSubtitle}</label>
          </div>
          <div className={`${images.freeTrial.featuresHeader.class} ${styles.infoImage}`}></div>
        </div>
        <label className={styles.subTitle}>{strings.subTitle}</label>
        <div className={styles.scrollContainer}>
          <FeatureList />
        </div>
      </div>
    </BottomSheet>
  )
}

export default FeaturesSheet
